(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq-accordion"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const toggle = event.target.closest('[data-faq-toggle]');
    if (!toggle) return;

    const card = toggle.closest('.faq-card');
    const accordion = toggle.closest('[data-faq-accordion]');
    if (!card || !accordion) return;

    const isOpen = card.classList.contains('is-open');

    accordion.querySelectorAll('.faq-card.is-open').forEach((openCard) => {
      openCard.classList.remove('is-open');
      openCard.querySelector('[data-faq-toggle]').setAttribute('aria-expanded', 'false');
    });

    if (!isOpen) {
      card.classList.add('is-open');
      toggle.setAttribute('aria-expanded', 'true');
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
